import React from 'react';
import GridServico from 'containers/PostosAtendimento/gridPostosAtendimento';
import TitlePage from 'components/TituloPage';
import { privateRoot } from 'routes/paths';
import * as S from '../styles';
import * as Style from 'components/Style';

export default function PageListarPostosAtendimento() {
  return (
    <S.ListPage>
      <TitlePage textTitle={'Listar Postos de Atendimento'} backPage={privateRoot} />
      <S.ContainGrid>
        <Style.GlobalCard>
          <GridServico />
        </Style.GlobalCard>
      </S.ContainGrid>
    </S.ListPage>
  );
}
